"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP);
export default function Topvpnpicksintro() {
  const container = useRef<HTMLDivElement>(null);
  const headlineWords = [{
    text: "Secure",
    italic: false,
    magenta: false
  }, {
    text: "your",
    italic: false,
    magenta: false
  }, {
    text: "digital",
    italic: true,
    magenta: true
  }, {
    text: "life",
    italic: false,
    magenta: false
  }, {
    text: "today",
    italic: false,
    magenta: false
  }];
  const floatingPins = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_shield_secure.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_shield_secure.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_shield_secure.webp-wvc-sizes",
    alt: "Digital security shield icon with orange accent border",
    className: "absolute top-[8%] left-[4%] w-24 md:w-32 lg:w-40 hidden md:block",
    rotate: "-12deg",
    delay: 0
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_lock_private.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_lock_private.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_lock_private.png-wvc-sizes",
    alt: "Privacy padlock icon with orange accent border",
    className: "absolute top-[38%] right-[3%] w-20 md:w-28 lg:w-36",
    rotate: "8deg",
    delay: 0.6
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_globe_global.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_globe_global.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1729652/img/hero_globe_global.webp-wvc-sizes",
    alt: "Global network connection icon with orange accent border",
    className: "absolute bottom-[14%] right-[18%] w-24 md:w-32 lg:w-40 hidden md:block",
    rotate: "-6deg",
    delay: 1.2
  }];
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".hero-word", {
        y: 24
      });
      gsap.to(".hero-word", {
        opacity: 1,
        y: 0,
        duration: 0.32,
        stagger: 0.06,
        ease: "power3.out"
      });
      gsap.to(".hero-eyebrow", {
        opacity: 1,
        duration: 0.4,
        ease: "power2.out"
      });
      gsap.set(".hero-follow", {
        y: 16
      });
      gsap.to(".hero-follow", {
        opacity: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.08,
        delay: 0.5,
        ease: "power3.out"
      });
      const pins = gsap.utils.toArray<HTMLElement>(".hero-pin");
      pins.forEach((pin, i) => {
        const rotation = pin.dataset.rotate || "0deg";
        const delay = parseFloat(pin.dataset.delay || "0");
        gsap.to(pin, {
          opacity: 1,
          scale: 1,
          duration: 0.6,
          delay: 0.3 + i * 0.12,
          ease: "back.out(1.6)"
        });
        gsap.to(pin, {
          y: "+=12",
          duration: 4,
          delay: delay,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut"
        });
      });
      gsap.to(".perf-dot", {
        opacity: 1,
        duration: 0.2,
        stagger: 0.04,
        delay: 0.8,
        ease: "power1.out"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".hero-word", ".hero-eyebrow", ".hero-follow", ".hero-pin", ".perf-dot"], {
        opacity: 1,
        y: 0,
        scale: 1
      });
    });
  }, {
    scope: container
  });
  return <section data-section-id="26639" id="topvpnpicksintro" data-nav="light" data-index={0} className="relative overflow-hidden bg-background pt-32 pb-24 md:pt-40 md:pb-36">
      <div ref={container} className="relative mx-auto max-w-[1240px] px-5 md:px-10">
        {}
        {floatingPins.map((pin, i) => <img key={i} data-index={i} src={pin.src} data-wvc-srcset={pin.srcset} data-wvc-sizes={pin.sizes} alt={pin.alt} loading="lazy" decoding="async" data-rotate={pin.rotate} data-delay={pin.delay} className={`hero-pin pointer-events-none z-0 ${pin.className}`} style={{
        opacity: 0,
        transform: `rotate(${pin.rotate}) scale(0.7)`,
        filter: "drop-shadow(0 8px 20px rgba(0,0,0,0.14))"
      }} />)}

        {}
        <div className="relative z-10 flex flex-col items-center text-center">
          {}
          <p className="hero-eyebrow font-sans text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground" style={{
          opacity: 0
        }}>
            {"Top Rated \u00B7 VPN Solutions"}
          </p>

          {}
          <h1 className="mt-6 max-w-[16ch] font-serif font-semibold text-foreground leading-[0.94] tracking-tight text-[clamp(3.25rem,8.5vw,7.5rem)]">
            {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-baseline">
                <span className="hero-word inline-block" style={{
              opacity: 0,
              color: word.magenta ? "var(--primary)" : undefined,
              fontStyle: word.italic ? "italic" : undefined
            }}>
                  {word.text}
                </span>
                {i < headlineWords.length - 1 && <span>&nbsp;</span>}
              </span>)}
          </h1>

          {}
          <p className="hero-follow mt-8 max-w-[560px] font-sans text-lg md:text-xl leading-[1.55] text-foreground/75" style={{
          opacity: 0
        }}>
            Fast, secure, and reliable VPN services for your home and office. Protect your data online.
          </p>

          {}
          <div className="hero-follow mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4" style={{
          opacity: 0
        }}>
            <Button asChild size="lg" className="h-12 rounded-lg px-7 font-sans text-[15px] font-semibold tracking-[0.01em] shadow-md hover:-translate-y-0.5 hover:bg-primary/90 transition-all duration-200" style={{
            color: "var(--primary-foreground)"
          }}>
              <Link to="/VpnReviewsPage">Compare VPNs</Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="h-12 rounded-lg border-[1.5px] border-foreground bg-transparent px-7 font-sans text-[15px] font-semibold tracking-[0.01em] text-foreground hover:bg-foreground hover:text-background transition-all duration-200">
              <Link to="https://vpngenix.com/go/NordVPN" newTab>Learn More</Link>
            </Button>
          </div>
        </div>

        {}
        <div className="relative z-10 mt-20 md:mt-28 flex items-center justify-center gap-3">
          {Array.from({
          length: 32
        }).map((_, i) => <span key={i} data-index={i} className="perf-dot h-1 w-1 rounded-lg bg-border" style={{
          opacity: 0
        }} />)}
        </div>
      </div>
    </section>;
}